import React from 'react';
import { ModalTitle as BootstrapModalTitle } from 'react-bootstrap';
function ModalTitle(props) {
  return /*#__PURE__*/React.createElement(BootstrapModalTitle, Object.assign({
    id: "modal-title"
  }, props));
}
export default ModalTitle;